import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container py-3 py-sm-5" }
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = { class: "input-group search-bar mx-auto" }
const _hoisted_4 = { class: "input-group-text bg-white border-end-0" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "p-2 position-absolute start-0" }
const _hoisted_7 = { class: "fw-bold py-2" }
const _hoisted_8 = { class: "quest-no" }
const _hoisted_9 = {
  key: 0,
  class: "text-secondary pb-2"
}

import { computed, reactive, ref, watch } from "vue";
import { remove, debounce } from "lodash";
import Icon from "@/components/Icon.vue";
import { Search, Add, Remove, Close } from "@/utility/icon";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionsAndAnswers',
  setup(__props) {

const data = reactive([
  {
    no: 1,
    question: "愛接送服務的對象是誰？",
    answer: "愛接送以服務「 持有身心障礙證明或搭乘輪椅行動不便者」 為主。",
  },
  {
    no: 2,
    question: "愛接送的車可以直接上下輪椅嗎？",
    answer:
      "可以， 愛接送所有的車輛都是無障礙計程車（ 已改名為通用計程車）， 輪椅可以直接上車。",
  },
  {
    no: 3,
    question: "愛接送如何計價？",
    answer: "愛接送「 按表收費不加價」。",
  },
  {
    no: 4,
    question: "如何預約訂車？",
    answer:
      "請選擇「 預約訂車」 功能， 且最晚須在搭車前一天14: 00 前完成預約。",
  },
  {
    no: 5,
    question: "「預約訂車」 成功後， 什麼時候派車？",
    answer:
      "車隊最晚將於「 搭車前一天20: 00 前」 完成派車， 並在APP「 我的訂單」 中顯示。",
  },
  {
    no: 6,
    question: "我有預約成功了， 但沒收到派車資訊時該怎麼辦？",
    answer:
      "請撥打該車隊客服電話尋求協助， 如無故不派車， 請向「 愛接送官方Line」 申訴。",
  },
  {
    no: 7,
    question: "如何臨時訂車？",
    answer:
      "若您已經超過「 預約訂車」 的時間， 可使用「 臨時訂車」 功能， 由車隊自由搶單。",
  },
  {
    no: 8,
    question: "使用臨時訂車時， 是否一定有車？",
    answer: "臨時訂車是由車隊自由搶單， 所以不一定有車。",
  },
  {
    no: 9,
    question: "使用候補訂車時， 是否一定有車？",
    answer: "候補訂車須視車隊訂單狀況而定， 所以不一定有車。",
  },
  {
    no: 10,
    question: "如何包車？",
    answer:
      "請選擇「 包車」 功能， 您可以在此查看各車隊之服務專線， 並請直接撥打專線與車隊討論包車事宜。",
  },
  {
    no: 11,
    question: "可以請司機在現場等候， 再載我回去嗎？",
    answer:
      "搭愛接送本質就像是搭計程車一樣， 司機等候時， 計費表會有費用產生。建議您將去程與回程分開預約。",
  },
  {
    no: 12,
    question: "看診時間不確定， 要怎麼預約回程？",
    answer:
      "建議回程先預留多一點時間， 若真的發生需要提早或延後的情況， 再請直接與司機或車隊聯繫協調。 只要不影響司機的前後趟任務， 車隊與司機會儘量服務的。",
  },
  {
    no: 13,
    question: "完成訂車後， 可以更改搭車時間或地點嗎？",
    answer:
      "訂單成立後不接受更改訂單內容。 請重新預約訂車後， 將原預約訂單取消即可。",
  },
  {
    no: 14,
    question: "可以取消預約嗎？",
    answer:
      "愛接送車輛有限， 請珍惜訂車。 如因故必須取消訂車時， 請於搭車前自行在APP「 我的訂單」 中按「 取消訂單」。",
  },
  {
    no: 15,
    question: "取消訂單後會有懲罰嗎？",
    answer:
      "在「 搭車前一天下午14: 00 後~超過乘車時間」 取消， 均會扣點， 一個月內累積5點便會有停權懲罰。 詳細停權規則請至個人頁面→ 違規紀錄→ 停權說明查看。",
  },
  {
    no: 16,
    question: "個人資料(如身分證字號) 填錯了， 該怎麼辦？",
    answer: "請您至個人頁面， 點選「 會員設定」 進行修改。",
  },
  {
    no: 17,
    question: "要怎麼知道我所在的區域有無提供愛接送服務？",
    answer:
      "請您直接在APP預約訂車， 若預約成功便是在服務範圍內。 也可以至個人頁面的服務範圍， 查看各車隊的聯繫電話及服務區域。",
  },
  {
    no: 18,
    question: "「具有效身心障礙證明」 欄位為何顯示「 驗證中」？",
    answer:
      "若是新註冊用戶（ 或變更身份證字號）， 在輸入「 身份證字號」 後須等約30分鐘， 系統自動連線衛福部資料庫， 確認是否「 具有效身心障礙證明」。",
  },
  {
    no: 19,
    question: "我明明具有「 身心障礙證明」 為何APP顯示為「 否」？",
    answer:
      "愛接送的身份審查係以衛福部資料庫為準， 如有疑慮， 請檢查身心障礙證明是否已經過期， 或洽所在地縣市政府查詢。",
  },
  {
    no: 20,
    question: "我有身心障礙證明， 搭愛接送有什麼優惠嗎？",
    answer:
      "愛接送目的之一在改善「 車資隨意加價行為」， 讓身障者享有與一般人搭計程車相同的待遇「 按表收費不加價」。",
  },
  {
    no: 21,
    question: "可以使用敬老愛心卡嗎？ 優惠方式是什麼？",
    answer:
      "部分縣市可以使用。 如臺北市、 桃園市、 臺中市、 高雄市(博愛卡) 等； 但各縣市優惠方式不同， 詳洽詢各縣市敬老愛心卡使用規定。",
  },
  {
    no: 22,
    question: "遇到司機說無法使用敬老愛心卡， 該怎麼辦？",
    answer: "請透過愛接送官方Line向我們申訴。",
  },
  {
    no: 23,
    question: "同時預約去程及回程， 為什麼只成功預約單趟次？",
    answer:
      "可能是因為A點在服務範圍內， 但B點不是， 導致只有單一趟次預約成功。 建議您直接電話詢問車隊可否一併承接去程及回程的趟次。",
  },
  {
    no: 24,
    question: "為什麼之前都可以預約， 現在卻顯示不在服務範圍內？",
    answer:
      "因服務範圍皆是由車隊自行訂定， 而車隊有自己的經營考量， 會定期針對範圍做異動調整。",
  },
  {
    no: 25,
    question: "可以指定特定司機嗎？",
    answer: "司機是由車隊依據業務進行指派， 較無法指定特定司機承接， 請見諒。",
  },
  {
    no: 26,
    question: "如何知道A地點到B地點的車資是多少？",
    answer:
      "在愛接送APP預約訂車時， 便會顯示預估車資， 但實際車資還是以計程車按表收費的金額為主。",
  },
  {
    no: 27,
    question: "如果被司機多收費用該怎麼辦？",
    answer: "請撥打該車隊客服電話或向「 愛接送官方Line」 申訴。",
  },
  {
    no: 28,
    question: "可以開收據證明嗎？",
    answer: "請搭完車後， 直接向司機索取收據。",
  },
  {
    no: 29,
    question: "有提供爬梯機嗎？",
    answer: "愛接送是以提供運輸服務為主， 因此並未有準備爬梯機。",
  },
  {
    no: 30,
    question: "最早可以在用車日的前幾天進行預約？",
    answer: "最早可在用車前14天進行預約。",
  },
  {
    no: 31,
    question: "除了電話之外， 可以傳送文字訊息給司機嗎？",
    answer:
      "可以。 當司機開始執行預約時， 您可以按下主畫面「 執行中」 的傳送訊息圖示， 便可用文字與司機聯絡。 但因司機是在行駛車輛的狀態， 不一定能立刻回覆。",
  },
]);
const query = ref("");
const isQueryNotEmpty = computed(() => query.value !== "");
const ClearQuery = () => (query.value = "");
const filterQuery = ref("");
const filterData = computed(() =>
  data.filter(
    (item) =>
      item.question.includes(filterQuery.value) ||
      item.answer.includes(filterQuery.value),
  ),
);
const debounceQuery = debounce((val) => (filterQuery.value = val), 300);
watch(() => query.value, debounceQuery);
const shows = reactive([] as number[]);
const toggleShow = (key: number) =>
  shows.includes(key) ? remove(shows, (item) => item == key) : shows.push(key);
const isShow = (key: number) => shows.includes(key);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-center" }, [
      _createElementVNode("h1", {
        id: "frequently-asked-questions",
        class: "mb-3 fw-light d-inline-block"
      }, [
        _createTextVNode(" 常見問題集 "),
        _createElementVNode("a", {
          class: "header-anchor",
          href: "#frequently-asked-questions",
          "aria-hidden": "true"
        }, "#")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(Icon, { icon: _unref(Search) }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          type: "email",
          class: _normalizeClass(["form-control border-start-0", { 'border-end-0': isQueryNotEmpty.value }]),
          id: "query-questions",
          placeholder: "搜尋"
        }, null, 2), [
          [_vModelText, query.value]
        ]),
        (isQueryNotEmpty.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "input-group-text bg-white border-start-0",
              onClick: ClearQuery
            }, [
              _createVNode(Icon, {
                icon: _unref(Close),
                width: "10px",
                height: "10px"
              }, null, 8, ["icon"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterData.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.no,
        class: "qa-combination position-relative py-3 border-bottom hover-point",
        onClick: ($event: any) => (toggleShow(item.no))
      }, [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(Icon, {
            icon: isShow(item.no) ? _unref(Remove) : _unref(Add)
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, "Q" + _toDisplayString(item.no), 1),
          _createTextVNode(". " + _toDisplayString(item.question), 1)
        ]),
        _createVNode(_Transition, { "enter-active-class": "animate__animated animate__fadeIn animate__faster" }, {
          default: _withCtx(() => [
            (isShow(item.no))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.answer), 1))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ], 8, _hoisted_5))
    }), 128))
  ]))
}
}

})